import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function scrollToHashElement(hash: string) {
    const raw = hash.replace(/^#/, "");
    if (!raw) return false;
    let id = raw;
    try {
        id = decodeURIComponent(raw);
    } catch {
        id = raw;
    }
    const el = document.getElementById(id);
    if (!el) return false;
    el.scrollIntoView({ behavior: "instant", block: "start" });
    return true;
}

export default function PageToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // 해시가 있으면 해당 id 요소로 스크롤 (ArticleTextSection 앵커 등)
        if (hash) {
            const tryScroll = () => scrollToHashElement(hash);
            requestAnimationFrame(() => {
                if (!tryScroll()) {
                    setTimeout(tryScroll, 100);
                    setTimeout(tryScroll, 400);
                }
            });
            return;
        }

        // 스크롤을 최상단으로 이동시키지 않을 페이지
        const pathsToExcludeFromScrollToTop = ['/App', '/Web', '/2024', '/2023', '/2022', '/2021'];

        if (!pathsToExcludeFromScrollToTop.includes(pathname)) {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
}